import { useEffect, useState } from "react";
import { LogIn } from "lucide-react";
import { api } from "../api";
import { Button, Card } from "../components/Ui";

export function BrowserLoginPage({
  onSuccess,
}: {
  onSuccess(): Promise<unknown>;
}) {
  const [error, setError] = useState("");
  const [challenge, setChallenge] = useState<{
    id: string;
    botUrl: string;
  } | null>(null);

  const loginWithBot = async () => {
    setError("");
    try {
      const created = await api.createWebChallenge();
      setChallenge(created);
      window.open(created.botUrl, "_blank", "noopener,noreferrer");
    } catch (caught) {
      setError(
        caught instanceof Error ? caught.message : "Не удалось начать вход",
      );
    }
  };

  useEffect(() => {
    if (!challenge) return;
    let polling = false;
    const timer = window.setInterval(async () => {
      if (polling) return;
      polling = true;
      try {
        const result = await api.consumeWebChallenge(challenge.id);
        if (result.approved && result.sessionToken) {
          window.localStorage.setItem("s168_session", result.sessionToken);
          window.clearInterval(timer);
          await onSuccess();
        }
      } catch (caught) {
        const message =
          caught instanceof Error ? caught.message : "Ошибка входа";
        if (!message.includes("истекла") && !message.includes("использована"))
          return;
        window.clearInterval(timer);
        setError(message);
        setChallenge(null);
      } finally {
        polling = false;
      }
    }, 2000);
    return () => window.clearInterval(timer);
  }, [challenge, onSuccess]);

  return (
    <main className="admin-login">
      <Card>
        <div className="login-icon">
          <LogIn />
        </div>
        <p className="eyebrow">SEREZHA168</p>
        <h1>Предложить идею</h1>
        <p>
          Войдите через Telegram, чтобы идеи и ответы были связаны с вашим
          аккаунтом в боте.
        </p>
        <Button onClick={loginWithBot} loading={Boolean(challenge)}>
          {challenge ? "Подтвердите вход в Telegram…" : "Войти через Telegram"}
        </Button>
        {error ? <p className="form-error">{error}</p> : null}
      </Card>
    </main>
  );
}
